<template>
    <div id="group_qrcode_create" v-if="status.show">
        <a-steps :current="current" style="margin: 40px 0;">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <a-divider />
        <div class="steps-content">
            <template v-if="current === 0">
                <a-alert type="info">
                    <div
                        slot="message"
                        class="base_font_size_14 base_font_color_606266"
                        style="line-height: 1.5; test-align:justify;"
                    >
                        <p>
                            1.
                            群活码未改变微信原有入群规则，只是把多个群二维码统一为固定的群活码，群满自动切换新群，无需手动更新二维码。
                        </p>
                        <p>
                            2.
                            为避免因延时而导致客户无法扫码入群，因此将扫码上限设为190，到达190时，若多人同时扫码，上限会大于190。
                        </p>
                        <p>
                            3.
                            若拉群人数大于190，生成群活码时请对应添加多个群聊，避免因群满员而无法进群。
                        </p>
                        <p>
                            4.
                            群活码适用于以图片方式分享朋友圈、群发目标客户等多种使用场景，请合理使用，禁止任何违法、违规用途。
                        </p>
                        <p>
                            5.
                            根据《微信外链管理规范》，违规内容/用途、用户投诉可能导致群活码被封，且申诉可能无法封解，具体以官方处理结果为准。
                        </p>
                    </div>
                </a-alert>
            </template>
            <template v-else-if="current === 1">
                <!-- 编辑群活码 -->
                <groupDetailEdit
                    type="add"
                    :status="status"
                    :currQcrode="form"
                    @backChangeForm="backChangeForm"
                ></groupDetailEdit>
            </template>
            <template v-else-if="current === 2">
                <!-- 管理群聊 -->
                <groupChatManage
                    type="add"
                    :currQcrode="groupChatForm"
                    :show="status.show"
                    @backChatId="backChatId"
                ></groupChatManage>
            </template>
            <template v-else-if="current === 3">
                <div class="main_center cross_center">
                    <div>
                        <div class="dir_top_nowrap cross_center" style="margin-bottom: 30px;">
                            <a-icon
                                type="check-circle"
                                class="base_font_color_ff5800"
                                style="font-size: 70px; line-height: 1;margin-bottom: 15px;"
                            />
                            <h2 style="text-align:center;">客户群活码创建成功！</h2>
                        </div>
                        <createQrcode
                            :fileName="qrcodeData.name"
                            :data="qrcodeParams"
                        ></createQrcode>
                        <!-- <img :src="qrcode" width="200" height="200" v-if="qrcode" /> -->
                        <!-- <div class="main_center cross_center" style="margin-top: 15px;">
                            <a-button-group>
                                <a-button
                                    type="link"
                                    size="small"
                                    @click="downloadImg(qrcodeData)"
                                    v-if="qrcodeData"
                                    >下载群码</a-button
                                >
                                <a-divider type="vertical" v-if="qrcodeData" />
                                <a-button
                                    type="link"
                                    size="small"
                                    @click="toCopy(qrcode)"
                                    v-if="qrcode"
                                    >复制链接</a-button
                                >
                            </a-button-group>
                        </div> -->
                        <div class="main_center cross_center" style="margin-top: 15px;">
                            <a-button type="primary" @click="toStatus(0)">完成</a-button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="step_affix" v-if="current < steps.length - 1">
            <a-affix class="affix_wrapper" :style="collapsed ? 'left:110px' : 'left: 230px'">
                <a-space>
                    <a-button @click="next" type="primary" v-if="current === 0">
                        开始新建
                    </a-button>
                    <a-space v-if="current > 0">
                        <a-button @click="prev">
                            上一步
                        </a-button>
                        <a-divider type="vertical" />
                    </a-space>
                    <a-button
                        :disabled="steps[current].next"
                        @click="next"
                        v-if="current < steps.length - 1 && current > 0 && current !== 2"
                    >
                        下一步
                    </a-button>
                    <!-- 提交表单数据 -->
                    <a-button :disabled="steps[current].next" @click="upForm" v-if="current === 2">
                        下一步
                    </a-button>
                </a-space>
            </a-affix>
        </div>
    </div>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import { mapState } from 'vuex';
import groupDetailEdit from '@/components/group/groupDetailEdit';
import groupChatManage from '@/components/group/groupChatManage';
import createQrcode from '@/components/group/createQrcode';
export default {
    // 新建群码
    name: 'group_qrcode_create',
    props: {
        // 当前页状态参数
        status: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        groupDetailEdit,
        groupChatManage,
        createQrcode
    },
    data() {
        return {
            qrcodeUrl: process.env.VUE_APP_DEFAULT + '/html/tool/qrcode?groupId=',
            current: 0,
            steps: [
                {
                    title: '使用须知',
                    next: false
                },
                {
                    title: '设置客户群活码基本信息',
                    next: false
                },
                {
                    title: '添加实际群活码',
                    next: false
                },
                {
                    title: '完成',
                    next: false
                }
            ],
            form: {},
            groupId: null,
            // 最终生成二维码
            // qrcode: '',
            qrcodeData: null,
            qrcodeParams: {
                qid: '1',
                correctLevel: 3,
                text: '未设置内容',
                logoSrc: '',
                logoScale: 0.2,
                logoMargin: 2,
                size: 300,
                margin: 10
            },
            // 群聊管理传参
            groupChatForm: {
                groupId: '',
                initNum: 0
            }
        };
    },
    created() {},
    computed: {
        ...mapState({
            collapsed: (state) => state.collapsed
        })
    },
    watch: {},
    mounted() {
        if (this.status.show) {
            this.getSign();
        }
    },
    methods: {
        next() {
            this.current++;
            if (this.current > 1) this.groupChatForm.initNum++;
            const data = this.form;
            if (!data.name || !data.scene) this.steps[this.current].next = true;
            else this.steps[this.current].next = false;
        },
        prev() {
            this.current--;
            const data = this.form;
            if (!data.name || !data.scene) this.steps[this.current].next = true;
            else this.steps[this.current].next = false;
        },
        // 设置群活码信息回传
        backChangeForm(data) {
            if (data) {
                if (!data.name || !data.scene) this.steps[this.current].next = true;
                else this.steps[this.current].next = false;
            }
            this.form = data;
        },
        // 设置群聊返回数据
        backChatId(data) {
            if (data && data.length > 0) {
                this.form.chatId = data;
                this.form.number = data.length;
            }
            if (data && data.length === 0 && this.form.chatId) {
                delete this.form.chatId;
            }
        },
        // 新增群码
        async getSign() {
            try {
                const res = await api.getSign();
                if (res.code !== 0) return this.$message.error('获取群码标记失败');
                this.groupId = res.sign;
                this.groupChatForm.groupId = res.sign;
            } catch (err) {
                console.log(err);
            }
        },
        // 新增群码
        async upForm() {
            try {
                const curr = this.form;
                let params = {};
                if (!curr || (curr && (!curr.name || !curr.scene)))
                    return this.$message.error(`请提交表单必填项数据`);
                if (Object.keys(this.form) && Object.keys(this.form).length > 0) {
                    Object.keys(this.form).forEach((key) => {
                        if (this.form[key]) params[key] = this.form[key];
                    });
                }
                if (this.groupId) params.groupId = this.groupId;
                const res = await api.createGroupQrcode(params);
                if (res.code !== 0) return this.$message.error('创建群聊报错');
                // this.qrcode = res.data.qrcode;
                this.qrcodeData = res.data;
                // 赋值二维码参数
                if (res.data && res.data.groupId) {
                    this.qrcodeParams.qid = res.data.groupId;
                    this.qrcodeParams.text = this.qrcodeUrl + res.data.groupId;
                }
                if (curr.logo) this.qrcodeParams.logoSrc = curr.logo;
                this.next();
            } catch (err) {
                console.log(err);
            }
        },
        // 返回群码列表
        toStatus(num) {
            if (num || num === 0) this.$emit('toChat', num);
        },
        // 下载图片
        async downloadImg(record) {
            if (!record || !record.id) return this.$message.error('下载员工码传参错误。');
            try {
                const res = await api.downloadGroupQrcode({ groupId: record.id });
                if (!res) return;
                if (record.qrcode) {
                    const arr = record.qrcode.split('.');
                    const format = '.' + arr[arr.length - 1];
                    this.downImgFile(record.name + format, res);
                } else {
                    return this.$message.error('群码还没生成');
                }
            } catch (err) {
                console.log(err);
            }
        },
        // 文件流下载方法
        downImgFile(file_name, content) {
            const csvData = new Blob([content]);
            // for IE
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(csvData, file_name);
            }
            // for Non-IE (chrome, firefox etc.)
            else {
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                const url = window.URL.createObjectURL(csvData);
                a.href = url;
                a.download = file_name;
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        },
        // 复制
        toCopy(data) {
            //创建一个 Input标签
            let oInput = document.createElement('input');
            oInput.value = data;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            // 执行浏览器复制命令
            /// 复制命令会将当前选中的内容复制到剪切板中
            /// 如这里构建的 Input标签
            document.execCommand('Copy');
            this.$message.success('复制成功！');
            ///复制成功后再将构造的标签 移除
            oInput.remove();
        }
    }
};
</script>

<style scoped>
#group_qrcode_create .steps-content {
    overflow: auto;
    height: calc(100vh - 506px);
}
#group_qrcode_create .steps-content::-webkit-scrollbar {
    display: none;
}
#group_qrcode_create .step_affix {
    width: 100%;
    height: 52px;
}
#group_qrcode_create .affix_wrapper {
    position: fixed;
    bottom: 81px;
    right: 47px;
    background: #fff;
    padding: 10px 30px;
    transition: all 0.2s;
}
#group_qrcode_create .group_affix {
    position: fixed;
    bottom: 81px;
    left: 230px;
    background: #fff;
    width: calc(100% - 275px);
    padding: 10px 30px;
    transition: all 0.3s;
    z-index: 10;
}
</style>
